/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HomePage } from './public/HomePage'
import { ServicesPage } from './public/ServicesPage'
import { ContactusPage } from './public/ContactusPage'
import { AboutusPage } from './public/AboutusPage'
import useGaTracker from './useGaTracker'
import { TosPage } from './public/TosPage'
import { ProivacyPolicyPage } from './public/ProivacyPolicyPage'


const Pages = () => {
  useGaTracker();

  return (
    <Routes>

      <Route exact path="/" element={
        <HomePage />
      } />
      <Route exact path="/services" element={
        <ServicesPage />
      } />

      <Route exact path="/contact-us" element={
        <ContactusPage />
      } />
      <Route exact path="/about-us" element={
        <AboutusPage />
      } />
      <Route exact path="/tos" element={
        <TosPage />
      } />
      <Route exact path="/privacypolicy" element={
        <ProivacyPolicyPage />
      } />
      
    </Routes>
  )

}



export default Pages
